import { useDisclosure } from '@mantine/hooks';
import { Flex, Burger, Menu, Title, rem } from '@mantine/core';
import {
  IconKey,
  IconUsers,
  IconLogout,
  IconApps,
  IconLicense,
  IconLogs,
} from '@tabler/icons-react';
import { AuthContextType, useAuth } from '../auth/AuthContext';
import { Link, useNavigate } from 'react-router-dom';

export const Navbar = () => {
  const [opened, { toggle }] = useDisclosure();
  const auth = useAuth();
  const navigate = useNavigate();

  return (
    <Flex p="md" gap={18} style={{ borderBottom: 'solid 1px #dee2e6' }}>
      {auth?.user ? (
        <Menu
          shadow="md"
          width={200}
          position="bottom-start"
          opened={opened}
          onChange={toggle}
        >
          <Menu.Target>
            <Burger
              opened={opened}
              onClick={toggle}
              aria-label="Toggle navigation"
            />
          </Menu.Target>

          <Menu.Dropdown>
            <Menu.Label>Application</Menu.Label>
            <Link style={{ textDecoration: 'none' }} to="/apps">
              <Menu.Item
                leftSection={
                  <IconApps style={{ width: rem(14), height: rem(14) }} />
                }
              >
                Apps
              </Menu.Item>
            </Link>
            <Link style={{ textDecoration: 'none' }} to="/api-keys">
              <Menu.Item
                leftSection={
                  <IconKey style={{ width: rem(14), height: rem(14) }} />
                }
              >
                API Keys
              </Menu.Item>
            </Link>
            <Link style={{ textDecoration: 'none' }} to="/logs/licenses">
              <Menu.Item
                leftSection={
                  <IconLogs style={{ width: rem(14), height: rem(14) }} />
                }
              >
                Usage logs
              </Menu.Item>
            </Link>

            {auth?.user?.roles.includes('manage-users') ? (
              <>
                <Menu.Divider />

                <Menu.Label>User management</Menu.Label>
                <Link style={{ textDecoration: 'none' }} to="/users">
                  <Menu.Item
                    leftSection={
                      <IconUsers style={{ width: rem(14), height: rem(14) }} />
                    }
                  >
                    Manage users
                  </Menu.Item>
                </Link>
              </>
            ) : null}

            <AuditItems auth={auth} />

            <Menu.Item
              color="red"
              leftSection={
                <IconLogout style={{ width: rem(14), height: rem(14) }} />
              }
              onClick={() => auth.signout(() => navigate('/'))}
            >
              Logout
            </Menu.Item>
          </Menu.Dropdown>
        </Menu>
      ) : null}
      <Title order={2}>License Manager</Title>
    </Flex>
  );
};

const AuditItems = ({ auth }: { auth: AuthContextType }) => {
  // Pulled this out into a separate component as it's not ready yet!
  return false &&
    (auth?.user?.roles.includes('audit-apps') ||
      auth?.user?.roles.includes('audit-users')) ? (
    <>
      <Menu.Divider />

      <Menu.Label>Audit changes</Menu.Label>

      {auth?.user?.roles.includes('audit-apps') && (
        <Link style={{ textDecoration: 'none' }} to="/audit/apps">
          <Menu.Item
            leftSection={
              <IconLicense style={{ width: rem(14), height: rem(14) }} />
            }
          >
            Audit app changes
          </Menu.Item>
        </Link>
      )}

      {auth?.user?.roles.includes('audit-users') && (
        <Link style={{ textDecoration: 'none' }} to="/audit/users">
          <Menu.Item
            leftSection={
              <IconUsers style={{ width: rem(14), height: rem(14) }} />
            }
          >
            Audit user changes
          </Menu.Item>
        </Link>
      )}
    </>
  ) : null;
};
